import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, Slider } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class WalkthroughService {
  constructor(private apiService: ApiService) {}

  list(): Observable<DataList<Slider>> {
    return this.apiService.get<DataList<Slider>>(`walkthroughs`).pipe();
  }
}
